/* global angular, _ */

(function () {
  'use strict';

  function typeahead(scope) {
    return function (query) {
      var params = {
        limit: 4
      };
      scope.searchTerm = query;
      scope.searchTermChanged = scope.searchTerm !== scope.savedSearchTerm;
      scope.searchApplied = scope.searchApplied && !scope.searchTermChanged || false;
      if (scope.searchApplied && !scope.searchTermChanged) {
        scope.savedSearchTerm = query;
      }
      if (scope.useLegacySearchParams === true) {
        params.searchBy = scope.searchBy || scope.defaultSearchBy;
        params.searchTerm = query;
      } else {
        if (_.isArray(scope.searchBy)) {
          _.each(scope.searchBy, function (s) {
            params['in_' + s] = query;
          });
          params._union = true;
        } else {
          params['in_' + (scope.searchBy || scope.defaultSearchBy)] = query;
        }
      }
      return scope.fetchSearchSuggestions(params).then(scope.mapSearchResults);
    };
  }
  angular.module('wsLrs.directives').controller('SearchBaseCtrl', ['$scope', '$http', function ($scope, $http) {
    $scope.processSearchResponse = $scope.processSearchResponse || function (response) {
      return response.data;
    };
    $scope.searchApiUrl = $scope.searchApiUrl || $scope.getApiUrl || $scope.apiUrl;
    $scope.defaultSearchBy = $scope.defaultSearchBy || "name";
    $scope.useLegacySearchParams = $scope.useLegacySearchParams || false;
    $scope.typeahead = typeahead($scope);
    $scope.searchPlaceholder = $scope.searchPlaceholder || "Search";
    $scope.searchMultiSelect = $scope.searchMultiSelect || false;
    if ($scope.searchMultiSelect) {
      $scope.selected = [];
    }
    $scope.removeSelection = function removeSelection(i) {
      $scope.selected.splice(i, 1);
    };
    $scope.fetchSearchSuggestions = $scope.fetchSearchSuggestions || function (params) {
      return $http.get(this.searchApiUrl, {
        params: params
      }).then(this.processSearchResponse);
    };
    $scope.mapSearchResults = $scope.mapSearchResults || function (data) {
      return _.map(data.results, function (item) {
        return $scope.formatSearchSuggestion(item);
      });
    };
    $scope.formatSearchSuggestion = $scope.formatSearchSuggestion || function (result) {
      return result.name;
    };
  }]).controller('ListerBaseCtrl', ['$scope', '$controller', '$http', '$sanitize', '$q', function ($scope, $controller, $http, $sanitize, $q) {
    $scope.defaultSortBy = $scope.defaultSortBy || "name";
    _.each($scope.sortControls, function (c) {
      //sanitize the title to prevent XSS
      c.title = $sanitize(c.title);
    });
    $scope.sortControls = $scope.sortControls || [];
    $scope.useLegacySortParams = $scope.useLegacySortParams || false;
    $scope.processFetchResponse = $scope.processFetchResponse || function (response) {
      return response.data;
    };
    $scope.getApiUrl = $scope.getApiUrl || $scope.apiUrl;
    $scope.fetchData = $scope.fetchData || function (params) {
      $scope.getApiUrl = $scope.getApiUrl || $scope.apiUrl;
      if ($scope.getApiUrl) {
        return $http.get($scope.getApiUrl, {
          params: params
        }).then($scope.processFetchResponse).catch(function (err) {
          return $q.reject(err);
        });
      } else {
        return $q.resolve({
          count: 0,
          results: []
        });
      }
    };
    $controller('SearchBaseCtrl', {
      $scope: $scope
    });
  }]).controller('ListerModalBaseCtrl', ['$scope', '$uibModal', '$controller', function ($scope, $uibModal, $controller) {
    $scope.showAddModal = function () {
      var modalInstance = $uibModal.open($scope.modalOptions);
      modalInstance.result.then(function (options) {
        $scope.$broadcast.apply($scope, options);
      });
    };
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
  }]).controller('ListerItemCtrl', ['$scope', '$http', function ($scope, $http) {
    $scope.editing = false;
    $scope.getPostData = $scope.getPostData || function () {
      return null;
    };
    $scope.getItem = $scope.getItem || function () {
      return $scope.item;
    };
    $scope.getItemId = $scope.getItemId || function (item) {
      return item.id;
    };
    $scope.saveSuccessEvent = $scope.saveSuccessEvent || "item-save";
    $scope.saveErrorEvent = $scope.saveErrorEvent || "item-save-error";
    $scope.deleteSuccessEvent = $scope.deleteSuccessEvent || "item-delete";
    $scope.deleteErrorEvent = $scope.deleteErrorEvent || "item-delete-error";
    $scope.updateApiUrl = $scope.updateApiUrl || $scope.apiUrl;
    $scope.deleteApiUrl = $scope.deleteApiUrl || $scope.apiUrl;
    $scope.saveSuccess = $scope.saveSuccess || function () {
      $scope.$emit($scope.saveSuccessEvent, $scope.$index);
    };
    $scope.saveError = $scope.saveError || function (response) {
      $scope.$emit($scope.saveErrorEvent, $scope.item, response);
    };
    $scope.deleteSuccess = $scope.deleteSuccess || function () {
      $scope.$emit($scope.deleteSuccessEvent, $scope.$index);
    };
    $scope.deleteError = $scope.deleteError || function (response) {
      $scope.$emit($scope.deleteErrorEvent, $scope.item, response);
    };
    $scope.createItemUrl = $scope.createItemUrl || function (baseUrl, item) {
      item = item || this.getItem();
      baseUrl = baseUrl || $scope.apiUrl;
      return baseUrl + '/' + this.getItemId(item);
    };
    $scope.save = function () {
      $http.put(this.createItemUrl(this.updateApiUrl), this.getPostData()).then(this.saveSuccess, this.saveError);
    };
    $scope.edit = function () {
      $scope.editing = true;
    };
    $scope.remove = function () {
      $http['delete'](this.createItemUrl(this.deleteApiUrl)).then(this.deleteSuccess, this.deleteError);
    };
  }]).directive('wsLister', ['Utils', 'ExplorerService', function wsLister(Utils, ExplorerService) {
    return {
      template: "<div ng-transclude></div>",
      replace: true,
      transclude: true,
      scope: false,
      compile: function wsListerCompile() {
        return {
          post: function wsListerPostLink(scope) {
            scope.searchBy = scope.defaultSearchBy;
            scope.searchTerm = "";
            scope.searchApplied = false;
            scope.savedSearchTerm = undefined;
            scope.searchTermChanged = false;
            scope.keystrokeSearch = scope.keystrokeSearch || false;
            scope.sortBy = Utils._try(function () {
              var preview = ExplorerService.getCard();
              var previewSort = Utils._try(function () {
                return preview.configuration.defaultSort;
              }, false);
              if (previewSort) {
                return preview.configuration.defaultSort;
              } else {
                return scope.config.defaultSort.toString();
              }
            }, scope.defaultSortBy);
            scope.minPage = 1;
            scope.pageNumber = 1;
            scope.maxPage = 1;
            scope.pageSize = scope.pageSize || 10;
            //If we haven't set the alternative page size, default it to 100.
            //This is checking for undefined, because a falsy value should be accepted to restrict it
            // from displaying the alternative page size controls
            scope.alternativePageSize = scope.alternativePageSize === undefined ? 100 : scope.alternativePageSize;
            scope.loading = true;
            scope.resultCount = 0;
            scope.currentListing = [];
            scope.mathMin = Math.min.bind(Math);
            scope.pageSizes = [5, 10, 25, 50, 100];
            scope.getSortDirection = function getSortDirection(control) {
              if (control && control.options) {
                var compoundDimension = control.title.includes('+');
                var containsExactMatch = _.contains(control.options, scope.sortBy);
                var isSecondCompoundDimension = scope.sortBy && scope.sortBy.includes('dimension[1]') && compoundDimension;
                if (containsExactMatch || isSecondCompoundDimension) {
                  return scope.sortBy.charAt(0) === '-' ? "down" : "up";
                }
              }
            };
            scope.getSortInfo = function getSortInfo(control) {
              if (control && control.options) {
                if (_.contains(control.options, scope.sortBy)) {
                  var sortInfo = _.property(scope.sortBy)(_.invert(control.options));
                  return _.without(sortInfo.split(' '), 'Ascending', 'Descending').join(' ');
                }
              }
            };
            scope.getSortCount = function getSortCount(control) {
              if (control && control.options) {
                return _.values(control.options).length;
              } else {
                return 0;
              }
            };
            scope.shouldShowElement = function shouldShowElement() {
              if (scope.pages && scope.pages.length > 1) {
                return true;
              }
              return scope.alternativePageSize && scope.alternativePageSize < scope.pageSize;
            };
            scope.resetPage = function resetPage() {
              scope.pageNumber = 1;
              return scope.fetch();
            };
            scope.setPage = function setPage(pageNumber) {
              if (pageNumber !== scope.pageNumber && pageNumber <= scope.maxPage && pageNumber >= scope.minPage) {
                scope.savedPageNumber = scope.pageNumber;
                scope.pageNumber = pageNumber;
                scope.fetch();
              }
            };
            scope.togglePageSize = function togglePageSize() {
              var tmp = scope.pageSize;
              scope.pageSize = scope.alternativePageSize;
              scope.alternativePageSize = tmp;
              scope.pageNumber = 1;
              scope.fetch();
            };
            scope.setPageSize = function (size) {
              var prevSize = scope.pageSize;
              scope.pageSize = size;
              var newPage = 1;
              if (scope.pageSize > prevSize) {
                newPage = Math.ceil(scope.pageNumber * prevSize / scope.pageSize);
              } else {
                newPage = Math.round((scope.pageNumber - 1) * prevSize / scope.pageSize + 1);
              }
              scope.maxPage = Math.ceil(scope.resultsCount / scope.pageSize);
              scope.pageNumber = newPage;
              scope.fetch();
            };
            scope.setSort = function setSort(sortBy) {
              scope.sortBy = sortBy;
              scope.pageNumber = 1;
              scope.fetch();
            };
            scope.resetPageListing = function resetPageListing() {
              scope.maxPage = Math.ceil(scope.resultCount * 1.0 / scope.pageSize);
              var lowerBound = Math.max(scope.pageNumber - 2, scope.minPage);
              var upperBound = Math.min(scope.pageNumber + 2, scope.maxPage);
              if (upperBound === scope.maxPage) {
                lowerBound = Math.max(upperBound - 4, scope.minPage);
              }
              if (lowerBound === scope.minPage) {
                upperBound = Math.min(lowerBound + 4, scope.maxPage);
              }
              var pages = [];
              for (var i = lowerBound; i <= upperBound; i++) {
                pages.push(i);
              }
              scope.pages = pages;
            };
            scope.typeahead = typeahead(scope);
            scope.search = function search(searchTerm) {
              scope.searchTermChanged = searchTerm !== scope.savedSearchTerm;
              scope.savedSearchTerm = scope.searchTerm;
              scope.searchTerm = searchTerm;
              scope.searchApplied = scope.searchTerm === scope.savedSearchTerm;
              scope.pageNumber = 1;
              return scope.fetch();
            };
            scope.fetch = scope.fetch || function fetch() {
              /*jshint camelcase: false */
              var params = {
                "_limit": scope.pageSize,
                "_offset": (scope.pageNumber - 1) * scope.pageSize
              };
              if (scope.sortBy && scope.sortBy.length > 0) {
                if (scope.useLegacySortParams === true) {
                  params.sortBy = scope.sortBy;
                } else {
                  params.order_by = scope.sortBy;
                }
              }
              scope.searchApplied = scope.searchTerm && scope.searchTerm.length > 0;
              if (scope.searchApplied) {
                if (scope.useLegacySearchParams === true) {
                  params.searchBy = scope.searchBy;
                  params.searchTerm = scope.searchTerm;
                } else if (_.isArray(scope.searchBy)) {
                  _.each(scope.searchBy, function (s) {
                    params['in_' + s] = scope.searchTerm;
                  });
                  params._union = true;
                } else {
                  params['in_' + (scope.searchBy || scope.defaultSearchBy)] = scope.searchTerm;
                }
              }
              scope.loading = true;
              return scope.fetchData(params).then(function (data) {
                if (!data) {
                  return;
                }
                scope.data = data;
                scope.resultCount = data.count;

                // If we're in a scenario in which we couldn't determine the total
                // number of records, hide some of the related controls.
                if (data.unableToDetermineTotal) {
                  scope.hideLastPageLink = true;
                  scope.hidePageLinks = true;
                  scope.hideTotalItems = true;

                  // If, because we don't know the total, we "ran past" the last page, then
                  // rewind back to the previous page, and disable the next page control
                  if (data.fetchedCount === 0) {
                    scope.loading = false;
                    scope.pageNumber = scope.savedPageNumber;
                    scope.maxPage = scope.pageNumber;
                    return;
                  }

                  // If this page is less than the page size, we know we've reached the
                  // end, and determined the total count
                  if (data.fetchedCount < scope.pageSize) {
                    scope.maxPage = scope.pageNumber;
                    scope.resultCount = (scope.pageNumber - 1) * scope.pageSize + data.fetchedCount;
                  }
                }

                // Result count is based ona distinct count using cardinality.  This uses the default
                // ES precision threshold of 3000, so if above 3000 this is an approximation.  Round
                // the number to accentuate that it's an estimate.
                if (scope.resultCount > 3000) {
                  scope.resultCount = Math.round(scope.resultCount / 100) * 100;
                  scope.resultCountRounded = true;
                }

                // Don't allow deep paging
                if (scope.resultCount >= 10000) {
                  scope.hideLastPageLink = true;
                }
                scope.currentListing = data.results;
                scope.resetPageListing();
                scope.loading = false;
              }).catch(function (err) {
                throw new Error(err.data ? err.data.exceptionMessage || err.data.message : err);
              });
            };
            scope.$on('item-added', function (evt, item) {
              scope.currentListing = scope.currentListing || [];
              scope.currentListing.push(item);
            });
            scope.$on('item-delete', function (evt, index) {
              scope.currentListing = scope.currentListing || [];
              scope.currentListing.splice(index, 1);
              scope.fetch().then(function () {
                return scope.setPage(scope.pageNumber > scope.maxPage ? scope.maxPage : scope.pageNumber);
              });
            });
            scope.$on('pager:set-page', function () {
              if (scope.searchTerm) {
                scope.search(scope.searchTerm);
              } else {
                scope.search();
              }
            });
            scope.search();
          }
        };
      }
    };
  }]);
})();
